module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui container fixed-header",
    attrs: {
      "id": "fixed-header"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "ui icon input"
  }, [_c('input', {
    class: {
      disabled: _vm.storeStatus.loading
    },
    attrs: {
      "id": "fixed-search-field",
      "type": "text",
      "placeholder": "Meklēt..."
    },
    domProps: {
      "value": _vm.searchTerm
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.setSearchTerm($event.target.value)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "search link icon",
    class: {
      disabled: _vm.storeStatus.loading
    },
    attrs: {
      "value": _vm.searchTerm
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setSearchTerm($event.target.offsetParent.firstChild.value)
      }
    }
  })])])]), _vm._v(" "), (!_vm.checkClientWidth) ? _c('div', {
    staticClass: "ui stackable secondary menu equal width grid compact"
  }, [_c('span', [_c('a', {
    staticClass: "link item",
    class: {
      disabled: _vm.storeStatus.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.filterCategory('', '', '', '', '', '')
      }
    }
  }, [_vm._v("Visi produkti")])]), _vm._v(" "), _vm._l((_vm.category), function(item) {
    return _c('span', [(item.category_a.length > 0) ? _c('div', {
      staticClass: "ui pointing dropdown link item categorymenu"
    }, [_c('span', {
      staticClass: "text",
      class: {
        disabled: _vm.storeStatus.loading
      }
    }, [_vm._v(_vm._s(item.category))]), _vm._v(" "), _c('i', {
      staticClass: "dropdown icon",
      class: {
        disabled: _vm.storeStatus.loading
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "menu"
    }, _vm._l((item.category_a), function(categorya) {
      return _c('div', {
        staticClass: "item",
        staticStyle: {
          "padding": "0 !important"
        }
      }, [_c('div', {
        staticStyle: {
          "padding": "11px 16px"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.filterCategory('', categorya.id, '', item.link, categorya.link, '')
          }
        }
      }, [(categorya.category_b.length > 0) ? _c('i', {
        staticClass: "dropdown icon"
      }) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "text"
      }, [_vm._v(_vm._s(categorya.category))])]), _vm._v(" "), (categorya.category_b.length > 0) ? _c('div', {
        staticClass: "menu"
      }, _vm._l((categorya.category_b), function(categoryb) {
        return _c('div', {
          staticClass: "item",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.filterCategory('', '', categoryb.id, item.link, categorya.link, categoryb.link)
            }
          }
        }, [_c('span', [_vm._v(_vm._s(categoryb.category))])])
      }), 0) : _vm._e()])
    }), 0)]) : _c('a', {
      staticClass: "item",
      class: {
        disabled: _vm.storeStatus.loading
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.filterCategory(item.id, '', '', item.link, '', '')
        }
      }
    }, [_vm._v(_vm._s(item.category))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "right menu mw-search-box"
  }, [_c('div', {
    staticClass: "item ms-search-box"
  }, [_c('div', {
    staticClass: "ui icon input"
  }, [_c('input', {
    class: {
      disabled: _vm.storeStatus.loading
    },
    attrs: {
      "id": "search-field",
      "type": "text",
      "placeholder": "Meklēt..."
    },
    domProps: {
      "value": _vm.searchTerm
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.setSearchTerm($event.target.value)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "search link icon",
    class: {
      disabled: _vm.storeStatus.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setSearchTerm($event.target.offsetParent.firstChild.value)
      }
    }
  })])])])], 2) : _c('div', [_c('div', {
    staticClass: "right menu mw-search-box"
  }, [_c('div', {
    staticClass: "item ms-search-box-mobile"
  }, [_c('div', {
    staticClass: "ui icon input",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('input', {
    attrs: {
      "id": "search-field",
      "type": "text",
      "placeholder": "Meklēt..."
    },
    domProps: {
      "value": _vm.searchTerm
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.setSearchTerm($event.target.value)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "search link icon",
    on: {
      "click": function($event) {
        return _vm.setSearchTerm($event.target.offsetParent.firstChild.value)
      }
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "https://bioveikals.com"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("./../assets/bv_logo_small.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-012cc768!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CategoryMenu.vue
// module id = 314
// module chunks = 1